import React from "react";
import "../ModalMouqabale.styles.scss";
import {
  TCreneau,
  TCurrentExchange,
  TMiniProfil,
  TMouqabalaStep,
} from "@/features/profile/types";
import { Button } from "@mui/material";
import { InlineIcon } from "@iconify/react";

interface MouqStep4Props {
  setStep?: React.Dispatch<React.SetStateAction<TMouqabalaStep>>;
  close?: () => void;
  receiver: TMiniProfil | null;
  selectedCreneau: Partial<TCreneau>;
}
const MouqStep4 = ({ close, receiver, selectedCreneau }: MouqStep4Props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <div className="rules confirm-alt">
        <div className="rules__icon-success">
          <InlineIcon icon="akar-icons:circle-check" className="icon" />
        </div>
        <p className="rules__title-alt">
          Demande de mouqabala avec{" "}
          <span style={{ color: "var(--ui-tertiary-shade" }}>
            {receiver?.username}
          </span>{" "}
          envoyée avec succès
        </p>
        {false && (
          <p className="rules__subtitle-alt">
            Le {selectedCreneau.creneau_date} • De{" "}
            {selectedCreneau.creneau_start_time} à{" "}
            {selectedCreneau.creneau_end_time}
          </p>
        )}
        <Button
          variant="contained"
          className="rules__confirm"
          onClick={() => {
            close!();
          }}
          color="primary"
        >
          Retour à la discussion
        </Button>
      </div>
    </div>
  );
};

export default MouqStep4;
